/**
 * Embed a Streamate camera ever 5 positions.
 */

import { StreamateCamera } from "components/ads/StreamateCamera";
import { FullScreenOnly } from "components/utils/FullScreenOnly";
import { VisibleOnly } from "components/utils/VisibleOnly";

interface IProps {
  position: number;
  tags: string[];
}

export const StreamateCameraDispatcher = ({ position, tags }: IProps) => {
  return (
    <FullScreenOnly key={`streamate-camera-${position}`}>
      <VisibleOnly className="GifPreview">
        <StreamateCamera tags={tags} />
      </VisibleOnly>
    </FullScreenOnly>
  );
};
